// extracted by mini-css-extract-plugin
export default {"container":"Points_container__kzJjE","rounds":"Points_rounds__IoFn4","points":"Points_points__PA5iD","roundsNumbers":"Points_roundsNumbers__mesqH"};